import { useEffect, useState } from 'react';
import CurrencyValue from '../currency-value';
import style from './style.module.scss';
import { LabeledItem } from '../../lib/typegen/labeled-item';

interface KvpItem extends LabeledItem<number> {
	forceRender?: boolean;
}

interface BalancesKvpListProps extends React.HTMLAttributes<HTMLElement> {
	kvpList: KvpItem[];
	totalSum?: KvpItem;
}

export default function BalancesKvpList({ kvpList, totalSum: total, className, ...rest }: BalancesKvpListProps) {
	const [list, setList] = useState<{ item: LabeledItem<number>; modififer?: string }[]>([]);

	useEffect(() => {
		setList(() => {
			const originalList = kvpList.filter((i) => i.value || i.forceRender).map((item) => ({ item }));
			// Only show total if there is more than one item in the list and total is defined
			if ((total && originalList.length > 1) || total?.forceRender) {
				return [...originalList.filter((i) => i.item.value), { item: total, modififer: style['item--total'] }];
			} else return [...originalList];
		});
	}, [kvpList, total]);

	return (
		<ul className={`${style.list} ${className}`} {...rest}>
			{list.map(({ item, modififer }) => (
				<li key={item.label} className={[style.list__item, style.item, modififer].join(' ')}>
					<span className={style.item__key}>{item.label}:</span>
					<span className={style.item__value}>
						<CurrencyValue value={item.value} />
					</span>
				</li>
			))}
		</ul>
	);
}
